"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _OpenIDClaimsImpl_ec, _OpenIDBuilder_claims;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenIDBuilder = void 0;
exports.ToOpenIDWireClaims = ToOpenIDWireClaims;
exports.FromOpenIDWireClaims = FromOpenIDWireClaims;
exports.DefaultOpenIDClaims = DefaultOpenIDClaims;
exports.TestOpenIDClaims = TestOpenIDClaims;
const claims_1 = require("./claims");
function ToOpenIDWireClaims(claims) {
    const ret = {};
    if ((0, claims_1.isSome)(claims.iss)) {
        ret.iss = (0, claims_1.toString)(claims.iss);
    }
    if ((0, claims_1.isSome)(claims.sub)) {
        ret.sub = (0, claims_1.toString)(claims.sub);
    }
    if ((0, claims_1.isSome)(claims.aud)) {
        ret.aud = (0, claims_1.toString)(claims.aud);
    }
    if ((0, claims_1.isSome)(claims.exp)) {
        ret.exp = (0, claims_1.toNumber)(claims.exp);
    }
    if ((0, claims_1.isSome)(claims.iat)) {
        ret.iat = (0, claims_1.toNumber)(claims.iat);
    }
    if ((0, claims_1.isSome)(claims.jti)) {
        ret.jti = (0, claims_1.toString)(claims.jti);
    }
    if ((0, claims_1.isSome)(claims.authTime)) {
        ret.auth_time = (0, claims_1.toNumber)(claims.authTime);
    }
    return ret;
}
function toEntity(x) {
    return {
        iss: claims_1.WithDefault.from(x.iss, ''),
        sub: claims_1.WithDefault.from(x.sub, ''),
        aud: claims_1.WithDefault.from(x.aud, ''),
        exp: claims_1.WithDefault.from(x.exp, -1),
        iat: claims_1.WithDefault.from(x.iat, -1),
        jti: claims_1.WithDefault.from(x.jti, ''),
        authTime: claims_1.WithDefault.from(x.authTime, -1),
    };
}
function FromOpenIDWireClaims(claims, defaults = {}) {
    const withDefaults = {
        ...ToOpenIDWireClaims(toEntity(defaults)),
        ...claims,
    };
    const ec = new claims_1.ErrorCollector('openid');
    return new OpenIDClaimsImpl(ec, {
        iss: (0, claims_1.requiredStringAttribute)(withDefaults, 'iss', '', ec),
        sub: (0, claims_1.requiredStringAttribute)(withDefaults, 'sub', '', ec),
        aud: (0, claims_1.requiredStringAttribute)(withDefaults, 'aud', '', ec),
        exp: (0, claims_1.requiredNumberAttribute)(withDefaults, 'exp', -1, ec),
        iat: (0, claims_1.requiredNumberAttribute)(withDefaults, 'iat', -1, ec),
        jti: (0, claims_1.requiredStringAttribute)(withDefaults, 'jti', '', ec),
        authTime: (0, claims_1.requiredNumberAttribute)(withDefaults, 'auth_time', -1, ec),
    });
}
class OpenIDClaimsImpl {
    constructor(ec, params) {
        _OpenIDClaimsImpl_ec.set(this, void 0);
        this.jti = () => {
            return this.defaulted.jti.val;
        };
        this.iss = () => {
            return this.defaulted.iss.val;
        };
        this.sub = () => {
            return this.defaulted.sub.val;
        };
        this.aud = () => {
            return this.defaulted.aud.val;
        };
        this.exp = () => {
            return this.defaulted.exp.val;
        };
        this.iat = () => {
            return this.defaulted.iat.val;
        };
        this.authTime = () => {
            return this.defaulted.authTime.val;
        };
        this.defaulted = params;
        __classPrivateFieldSet(this, _OpenIDClaimsImpl_ec, ec, "f");
    }
    wireIss() {
        return (0, claims_1.fromWire)(this.defaulted.iss);
    }
    wireSub() {
        return (0, claims_1.fromWire)(this.defaulted.sub);
    }
    wireAud() {
        return (0, claims_1.fromWire)(this.defaulted.aud);
    }
    wireExp() {
        return (0, claims_1.fromWire)(this.defaulted.exp);
    }
    wireIat() {
        return (0, claims_1.fromWire)(this.defaulted.iat);
    }
    wireAuthTime() {
        return (0, claims_1.fromWire)(this.defaulted.authTime);
    }
    wireJti() {
        return this.defaulted.jti.val;
    }
    errors() {
        return __classPrivateFieldGet(this, _OpenIDClaimsImpl_ec, "f").errors;
    }
    isError() {
        return __classPrivateFieldGet(this, _OpenIDClaimsImpl_ec, "f").isError();
    }
    lastError() {
        return __classPrivateFieldGet(this, _OpenIDClaimsImpl_ec, "f").lastError();
    }
    toJSON() {
        return ToOpenIDWireClaims(this.defaulted);
    }
    toParams() {
        const wc = this.toJSON();
        return {
            iss: wc.iss,
            sub: wc.sub,
            aud: wc.aud,
            exp: wc.exp,
            iat: wc.iat,
            jti: wc.jti,
            authTime: wc.auth_time,
        };
    }
}
_OpenIDClaimsImpl_ec = new WeakMap();
/**
 * @deprecated use TestOpenIDClaims instead
 */
function DefaultOpenIDClaims() {
    return TestOpenIDClaims();
}
function TestOpenIDClaims(now = Date.now()) {
    return {
        iss: 'iss',
        sub: 'sub',
        aud: 'aud',
        exp: now + 3600 * 1000,
        iat: 7,
        jti: 'jti',
        authTime: now,
    };
}
class OpenIDBuilder {
    constructor(claims) {
        _OpenIDBuilder_claims.set(this, void 0);
        __classPrivateFieldSet(this, _OpenIDBuilder_claims, claims, "f");
    }
    build() {
        return FromOpenIDWireClaims({}, __classPrivateFieldGet(this, _OpenIDBuilder_claims, "f"));
    }
    timeStamp(now) {
        __classPrivateFieldGet(this, _OpenIDBuilder_claims, "f").exp = now + 3600 * 1000;
        __classPrivateFieldGet(this, _OpenIDBuilder_claims, "f").authTime = now;
        return this;
    }
    aud(aud) {
        __classPrivateFieldGet(this, _OpenIDBuilder_claims, "f").aud = aud;
        return this;
    }
    authTime(authTime) {
        __classPrivateFieldGet(this, _OpenIDBuilder_claims, "f").authTime = authTime;
        return this;
    }
    exp(exp) {
        __classPrivateFieldGet(this, _OpenIDBuilder_claims, "f").exp = exp;
        return this;
    }
    iat(iat) {
        __classPrivateFieldGet(this, _OpenIDBuilder_claims, "f").iat = iat;
        return this;
    }
    iss(iss) {
        __classPrivateFieldGet(this, _OpenIDBuilder_claims, "f").iss = iss;
        return this;
    }
    sub(sub) {
        __classPrivateFieldGet(this, _OpenIDBuilder_claims, "f").sub = sub;
        return this;
    }
}
exports.OpenIDBuilder = OpenIDBuilder;
_OpenIDBuilder_claims = new WeakMap();
//# sourceMappingURL=open-id-claims.js.map